export enum AppDefaultToolkit {
  WebSearch = "webSearch",
  Thinking = "thinking",
}

export enum DefaultToolName {
  WebSearch = "webSearch",
  WebContent = "webContent",
}

export const SequentialThinkingToolName = "sequential-thinking";
